import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './SubTabBar.css';

const SubTabBar = ({ tabs }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="sub-tab-bar">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.path || 
          (tab.path === '/builders' && [
            '/builders', 
            '/quiz-builder', 
            '/visual-builder', 
            '/virtual-desk', 
            '/complex-builder', 
            '/certificates', 
            '/pairing-builder'
          ].some(path => location.pathname.startsWith(path)));
        return (
          <button
            key={tab.path}
            className={`sub-tab-btn ${isActive ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            {tab.icon && <span className="sub-tab-icon">{tab.icon}</span>}
            <span>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default SubTabBar;
